module.exports = __webpack_public_path__ + "static/media/icon-print-white.bce5bcca.svg";